export interface ColoresTema {
  primary: string;
  primaryHover: string;
  primaryActive: string;
  primaryDark: string;
  primaryDarkHover: string;
  primaryDarkActive: string;
  primaryLight: string;
  primaryLightHover: string;
  primaryLightActive: string;
}

export type NombreTema = 'deudor' | 'emisor' | 'fondeador' | 'segundoEmisor';

export const TEMA_POR_DEFECTO: NombreTema = 'deudor';

export const TEMAS: Record<NombreTema, ColoresTema> = {
  deudor: {
    primary: '#1E3A8A',
    primaryHover: '#1B347C',
    primaryActive: '#182E6E',
    primaryDark: '#1E3A8A',
    primaryDarkHover: '#1E3A8A',
    primaryDarkActive: '#0f1f4a',
    primaryLight: '#4a67af',
    primaryLightHover: '#DDE1ED',
    primaryLightActive: '#B9C2DB'
  },
  emisor: {
    primary: '#660066',
    primaryHover: '#804080',
    primaryActive: '#520052',
    primaryDark: '#3d003d',
    primaryDarkHover: '#4d1a4d',
    primaryDarkActive: '#2d002d',
    primaryLight: '#9966cc',
    primaryLightHover: '#a87dd4',
    primaryLightActive: '#8a55c4'
  },
  fondeador: {
    primary: '#008080',
    primaryHover: '#20a0a0',
    primaryActive: '#006666',
    primaryDark: '#004d4d',
    primaryDarkHover: '#1a6666',
    primaryDarkActive: '#003d3d',
    primaryLight: '#4daaaa',
    primaryLightHover: '#66b8b8',
    primaryLightActive: '#3d9999'
  },
  segundoEmisor: {
    primary: '#616161',
    primaryHover: '#757575',
    primaryActive: '#525252',
    primaryDark: '#424242',
    primaryDarkHover: '#525252',
    primaryDarkActive: '#333333',
    primaryLight: '#9e9e9e',
    primaryLightHover: '#ababab',
    primaryLightActive: '#8f8f8f'
  }
};

export const MAPA_VARIABLES_CSS: Record<keyof ColoresTema, string> = {
  primary: '--theme-primary',
  primaryHover: '--theme-primary-hover',
  primaryActive: '--theme-primary-active',
  primaryDark: '--theme-primary-dark',
  primaryDarkHover: '--theme-primary-dark-hover',
  primaryDarkActive: '--theme-primary-dark-active',
  primaryLight: '--theme-primary-light',
  primaryLightHover: '--theme-primary-light-hover',
  primaryLightActive: '--theme-primary-light-active'
};

export const VARIABLES_CSS_LEGACY: Record<string, keyof ColoresTema> = {
  '--color-azul-principal': 'primary',
  '--color-azul-texto-menu': 'primaryLight'
};
